module.exports = __webpack_public_path__ + "img/house-blue.f3f1abba.svg";